export class GreenCardRequest {
    id: number = (new Date()).getTime();
    type: string = 'green_card';
    beginDate: string;
    endDate: string | null;
    dateBeginOrig: string | null;
    policyNumber: string;
    crn: string;
    category: string;
    brand: string;
}